import avatar from "@/assets/hud/header/avatar.png";

export const USER = {
  wallet: null,
  id: 1,
  transactions:null,
  url: avatar.src,
  canContinueMultiplier:true,
  balance: {
    ton: 0,
    coins: 0,
    pearls: 0,
    multipliers_boosters: {
      booster: "",
      time_remaing: 0,
      boosterID: null,
      canContinue:false,
      allCount:0,
      count:0
    },
    map:[],
    super_boster: null,
    auto_boosters: {
      quantity: 0,
    },
    keys_cheast: 0,
    lastOpenedChestIndex: null,
  },
  license_capitan:false,
  license_capitan_expires:"",
  chests: [],
  username: "User",
  ref: 0,
  is_premium: false,
  stats: {
    count_ref_lvl1: 0,
    count_ref_lvl2: 0,
    earned_from_lvl1: 0,
    earned_from_lvl2: 0,
    rewards_pearl: {
      earned_pearls: 0,
    },
    rewards_keys: {
      earned_keys: 0,
    },

    total_gold: 0,
    total_pearls: 0,
    league: "Bronze",
  },
  firstExperience: null,
};
